// app/studente/incarichi.js

(function () {
    'use strict';
    var controllerId = 'tipoLicenza';
    angular.module('app').controller(controllerId, ['$rootScope', '$routeParams', 'common', 'bootstrap.dialog', '$uibModal', 'datacontext', 'sectionMenu', '$translate', tipoLicenza]);

    function tipoLicenza($rootScope, $routeParams, common, bDialog, $uibModal, datacontext, sectionMenu, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard

        var vm = this;
        vm.title = 'Tipo Licenza';
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);
        vm.record = {};
        vm.records = [];
        vm.loading = false;
        //vm.view = 'list';
        vm.super = $rootScope.isAuthorized('SUPER');

        vm.list = {};
        vm.list.ordine = ['Titolo'];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            //vm.cerca();
        };
        vm.objName = "tipoLicenza"; //Utilizzato per pannello modale
        //vm.addTitle = $translate.instant('NuovaLicenza');
        vm.addTitle = 'Nuova Licenza';

        //Filtro
        vm.filter = '';
        //vm.filter.titolo = '';

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        //vm.get = getRecord;
        vm.add = openModal;
        vm.open = openModal;
        vm.update = updateItem;
        vm.delete = deleteItem;

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [];
            common.activateController(promises, controllerId).then(function () {});
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.page = 1;
            //vm.filter.titolo = vm.fTitolo == null ? '' : vm.fTitolo;
            vm.loading = false;
            return getAllByFilter();
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords > 0 && vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.tipoLicenza_getAll()
                .then(function (data) {
                    if (data.constructor === Array) {
                        vm.page++;
                        data.forEach(function (item) {
                            vm.records.push(item);
                        });
                    }
                    vm.loading = false;
                    vm.countRecords = data.length;
                });
        }

        //function getRecord(id, index) {
        //    return datacontext.avviso_get(id).then(function (data) {
        //        vm.index = index;
        //        vm.record = data;

        //        setView('detail');
        //    });
        //}

        function updateItem() {
            return datacontext.tipoLicenza_update(vm.record).then(function (data) {                
                vm.records[vm.index] = data;
                logSuccess('Dato salvato ');
            });
        }

        function deleteItem(item) {
            var msg = ' la licenza ' + item.Titolo;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.tipoLicenza_delete(item.Id).then(function (data) {
                    if (data != "200") return logError('Errore durante la rimozione del dato');
                    logSuccess('Record eliminato ');
                    cerca();
                });
            });
        }

        //****************************************************
        // METODI Licenza 
        //****************************************************
        function addLicenza(item) {
            return datacontext.tipoLicenza_add(item).then(function (data) {
                if (!data || data.Id == null || data.Id == 0) { logError($translate.instant('ErroreCreazione')); return; }

                logSuccess($translate.instant('DatoCreato'));
                vm.records.push(data);
                vm.countRecords++;
            });
        }

        //function getMateria(id) {
        //    return datacontext.materia_get(id).then(function (data) {
        //        return data;
        //    });
        //}

        function updateLicenza(item) {
            return datacontext.tipoLicenza_update(item).then(function (data) {
                if (data)
                    logSuccess($translate.instant('DatoSalvato'));
                else
                    logError($translate.instant('ImpossibileSalvareDati'));
            });
        }

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function openModal(objLicenza, index) {
            var newLicenza = !objLicenza;

            if (newLicenza) {
                objLicenza = {};
            }

            var modalLicenza = {};
            angular.copy(objLicenza, modalLicenza);
            //modalLicenza.Id = vm.record.Id;


            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/tipoLicenza/modal/tipoLicenzaAddEdit.html?version=3',
                controller: 'tipoLicenzaAddEdit',
                resolve: {
                    licenza: function () {
                        return modalLicenza;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (newLicenza) {
                    addLicenza(returnItem);
                }
                else {
                    updateLicenza(returnItem);
                    angular.copy(returnItem, objLicenza);
                }
            });
        };
    }
})();
